import { render, staticRenderFns } from "./responsibility-zrqareaItem.vue?vue&type=template&id=12e3e38a&scoped=true&"
import script from "./responsibility-zrqareaItem.vue?vue&type=script&lang=js&"
export * from "./responsibility-zrqareaItem.vue?vue&type=script&lang=js&"
import style0 from "./responsibility-zrqareaItem.vue?vue&type=style&index=0&id=12e3e38a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e3e38a",
  null
  
)

export default component.exports